export function useShopEnabled() {
  const shopEnabled = useRuntimeConfig().public.SHOP_ENABLED;
  return typeof shopEnabled === 'number'
    ? shopEnabled === 1
    : shopEnabled === '1';
}
